import React from 'react';

const PageHeader = ({ title, description, eyebrow, rightContent, className = '' }) => (
  <header className={`partner-portal-hero ${className}`.trim()}>
    <span className="partner-portal-hero-accent-bar" aria-hidden="true" />
    <span className="partner-portal-hero-shine" aria-hidden="true" />
    <div className="partner-portal-hero-main">
      {eyebrow ? (
        <p className="partner-portal-hero-eyebrow">{eyebrow}</p>
      ) : null}
      <h1 className="partner-portal-hero-title">{title}</h1>
      {description ? (
        <p className="partner-portal-hero-description">{description}</p>
      ) : null}
    </div>
    {rightContent ? (
      <div className="partner-portal-hero-actions">
        <div className="partner-portal-hero-actions-inner">{rightContent}</div>
      </div>
    ) : null}
  </header>
);

export default PageHeader;
